export default function IconExternalLink() {
  return (
    <div className="type-externallink1">
      <svg
        className="w-4 h-4"
        preserveAspectRatio="none"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13 16H2C1.46957 16 0.960859 15.7893 0.585786 15.4142C0.210714 15.0391 0 14.5304 0 14V3C0 2.46957 0.210714 1.96086 0.585786 1.58579C0.960859 1.21071 1.46957 1 2 1H6V3H2V14H13V10H15V14C15 14.5304 14.7893 15.0391 14.4142 15.4142C14.0391 15.7893 13.5304 16 13 16ZM7.7 9.707L6.29 8.293L12.583 2H9V0H16V7H14V3.415L7.7 9.707Z"
          fill="#323232"
        ></path>
      </svg>
    </div>
  );
}
